import { Range } from "@pdfking/tfunc"
import Icon from "@pdfking/workflow/components/Icon"
import { defineComponent } from "vue"

export default defineComponent({
  computed: { range: () => [...Range(2, 10, 2)] },
  data() {
    return {
      local: this.value,
    }
  },
  props: ["name", "value"] as const,
  render() {
    return (
      <div class="rating-widget">
        <input name={this.name} type="hidden" value={this.local} />
        {this.range.map((i: number) => (
          <Icon
            key={i}
            style="cursor: pointer"
            name={i <= this.local ? "STAR" : "STAR_EMPTY"}
            onClick={() => {
              this.local = i
            }}
          />
        ))}
      </div>
    )
  },
})
